import React, { useState } from "react";
import { AdvancedSearchHeader } from "./AdvancedSearchHeader";
import { AdvancedSearchMobileMenu } from "./AdvancedSearchMobileMenu";
import { AdvancedSearchMobileSection } from "./AdvancedSearchMobileSection";

/**
 * Renderiza la versión móvil del menú de búsqueda avanzada.
 *
 * El componente presenta un menú principal desde el que el usuario puede
 * seleccionar una categoría de búsqueda. Al hacerlo, muestra la sección
 * correspondiente mediante una transición entre vistas, permitiendo regresar
 * al menú principal o cerrar la búsqueda avanzada.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textos - Objeto con los textos e internacionalización de la interfaz.
 * @param {Object} props.data - Datos utilizados para construir las opciones de búsqueda.
 * @param {Function} [props.onClose] - Función opcional que cierra el menú de búsqueda avanzada.
 * @returns {JSX.Element} AdvancedSearchMobile
 */
export const AdvancedSearchMobile = ({
    textos,
    data,
    onClose,
}) => {
    const [activeSection, setActiveSection] = useState(null);

    const handleBack = () => {
        setActiveSection(null);
    };

    return (
        <section
            className="menu"
            onClick={(event) => event.stopPropagation()}
        >
            <div
                className="content pt-4 px-3"
                onClick={(event) => event.stopPropagation()}
            >
                <div
                    className={`advanced-search-mobile__page 
                        ${activeSection
                            ? "page-left"
                            : "page-active"
                        }`}
                >
                    <AdvancedSearchHeader
                        textos={textos}
                    />

                    <AdvancedSearchMobileMenu
                        textos={textos}
                        onSelect={setActiveSection}
                    />
                </div>

                <div
                    className={`advanced-search-mobile__page ${activeSection ? "page-active" : "page-right"
                        }`}
                >
                    <AdvancedSearchMobileSection
                        section={activeSection}
                        textos={textos}
                        data={data}
                        onBack={handleBack}
                        onClose={onClose}
                    />
                </div>
            </div>

        </section>
    );
};